export default "__VITE_ASSET__BXf4cLq8__"